import { TimelineItem } from './types';

const getAuthorName = (
  item: TimelineItem,
  employeeNames: Record<string, any>,
  getFullName: (name: any) => string,
): string => {
  const alias = item.author || item.employee;
  if (!alias) return 'Unknown';

  const nameData = employeeNames[alias];
  if (nameData && nameData.nameEn) {
    return getFullName(nameData.nameEn);
  }

  return alias;
};

export default { getAuthorName };
